<div
  *ngIf="loading"
  class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-10"
>
  <div class="bg-gray-100 opacity-50 h-screen w-screen absolute"></div>
  <mat-spinner></mat-spinner>
</div>
<section *ngIf="isDateInRange">
  <div class="md:flex">
    <div>
      <a href="./choose-product?disc=CYBERFIL50"
        ><img
          src="./assets/cyberfil/banner_50.png"
          alt="Descuento 50%"
          class="sm:opacity-100 opacity-75 transition-all duration-300 hover:opacity-100 hover:drop-shadow-sm"
      /></a>
    </div>
    <div>
      <a href="./choose-product?disc=CYBERFIL20"
        ><img
          src="./assets/cyberfil/banner_20.png"
          alt="Descuento 20% x 3 meses"
          class="sm:opacity-100 opacity-75 transition-all duration-300 hover:opacity-100 hover:drop-shadow-sm"
      /></a>
    </div>
  </div>
</section>
<!-- <h1 class="font-bold text-5xl text-primary text-center mb-10">Elegí tu plan.</h1> -->
<h2
  *ngIf="zip_code && viewProducts && viewProducts.length > 0"
  class="font-bold text-3xl text-green-500 text-center"
>
  ¡Felicidades!
</h2>
<h3
  *ngIf="zip_code && viewProducts && viewProducts.length > 0"
  class="text-2xl text-primary font-bold text-center"
>
  De acuerdo a tu código postal {{ zip_code }}, tenemos cobertura y te
  recomendamos los siguientes planes:
</h3>
<h3
  *ngIf="zip_code && viewProducts && viewProducts.length > 0"
  class="text-2xl text-primary font-bold text-center"
>
  ¿Deseas cambiar tu código postal?
</h3>
<!--<div class="font-bold text-3xl text-primary text-center bg-gray-100 pt-10 pb-5">Productos</div>-->
<h3
  *ngIf="
    (zip_code && !viewProducts && !loading) ||
    (zip_code && viewProducts.length == 0 && !loading)
  "
  class="text-2xl text-primary font-bold text-center"
>
  <p>¡Malas noticias!</p>
  <p>Por el momento no tenemos productos para ofrecerte</p>
</h3>

<!--<div
    *ngIf="!loading"
    class="font-bold text-2xl md:text-3xl text-primary text-center bg-gray-200 pt-10 pb-5"
  >
    Dispensers
  </div>-->

<!-- inicio de productos-->
<section class="relative pb-20 mt-0 mb-0">
  <div
    *ngIf="!loading"
    class="relative z-0 py-12 md:py-16 bg-gradient-to-b from-gray-50 to-white"
  >
    <div
      class="items-center justify-center relative text-center max-w-7xl mx-auto px-5 animate-fadeInUp"
    >
      <div class="inline-block">
        <h1 class="text-primary text-3xl md:text-5xl font-bold mb-4">
          Suscripción <span class="text-secondary">Mensual</span>
        </h1>
        <div
          class="h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full mb-6"
        ></div>
      </div>
      <h3 class="text-gray-700 text-lg md:text-xl max-w-3xl mx-auto">
        Excelencia en purificación y una amplia gama de
        <strong class="text-primary">dispensers ideales</strong> para tu día a
        día
      </h3>
    </div>
  </div>
  <div
    class="flex items-center justify-center mx-0 mt-3"
    *ngIf="viewProducts && viewProducts.length > 0"
  >
    <!-- Botón previo (solo desktop y cuando hay más de 4) -->
    <button
      class="text-primary hidden md:block mr-3 transition-all duration-200 hover:opacity-70 hover:scale-110"
      (click)="prevProducts()"
      *ngIf="showCarousel"
      aria-label="Anterior"
    >
      <svg
        class="w-10 h-10 rotate-180 drop-shadow-md"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        ></path>
      </svg>
    </button>

    <!-- Contenedor principal del carrusel con overflow hidden -->
    <div
      class="overflow-hidden px-0 md:px-10"
      style="width: 100%; max-width: 1200px; min-height: 580px"
    >
      <div
        class="flex flex-col md:flex-row gap-10 transition-transform duration-1500 ease-out justify-center items-center"
        [style.transform]="'translateX(0px)'"
      >
        <div
          *ngFor="let product of getVisibleProducts(); let i = index"
          (click)="product?.out_of_stock !== 1 && productDetail(product, 'sub')"
          class="mb-4 md:mb-0 flex flex-col group bg-white hover:shadow-strong shadow-medium rounded-2xl p-6 text-center transition-all duration-500 ease-out flex-shrink-0"
          [class.cursor-not-allowed]="product?.out_of_stock === 1"
          [class.cursor-pointer]="product?.out_of_stock !== 1"
          [class.opacity-50]="!isMobile && i !== 1"
          [class.scale-95]="!isMobile && i !== 1"
          [class.opacity-100]="isMobile || i === 1"
          [class.scale-105]="!isMobile && i === 1"
          [class.shadow-strong]="!isMobile && i === 1"
          [class.transform]="!isMobile && i === 1"
          [class.-translate-y-6]="!isMobile && i === 1"
          [class.z-10]="!isMobile && i === 1"
          style="
            user-select: none;
            width: 300px;
            min-height: 520px;
            max-width: 300px;
          "
        >
          <div
            class="text-center flex-shrink-0 flex flex-col justify-center items-center bg-gradient-to-b from-gray-50 to-white rounded-xl p-4 mb-4"
          >
            <div
              class="relative flex justify-center items-center"
              style="height: 190px; width: 100%"
            >
              <img
                class="group-hover:scale-110 mx-auto transform transition duration-500 ease-out object-contain drop-shadow-md"
                style="height: 180px; max-width: 100%"
                [src]="product?.imageUrl"
                alt=""
              />
            </div>
            <div
              *ngIf="product?.out_of_stock === 1"
              class="bg-gradient-to-r from-red-500 to-red-600 font-bold text-center py-2 px-6 rounded-full text-white text-sm w-fit shadow-medium mt-2"
            >
              AGOTADO
            </div>
            <div
              *ngIf="
                product?.allow_self_contracting === 0 &&
                product?.out_of_stock !== 1
              "
              class="bg-gradient-to-r from-secondary to-green-600 font-bold text-center py-2 px-6 rounded-full text-white text-sm w-fit shadow-medium mt-2"
            >
              CONSULTANOS
            </div>
          </div>

          <div
            class="h-0.5 w-16 bg-gradient-to-r from-primary to-secondary rounded-full mx-auto my-4"
          ></div>

          <div class="text-primary font-bold text-2xl pb-2 leading-tight">
            {{ product?.name }}
          </div>

          <div class="flex items-end justify-center">
            <img
              src="assets/vaso_frio.png"
              alt=""
              class="w-21 h-37 pr-4 my-1"
            />
            <img src="assets/vaso_caliente.png" alt="" class="w-21 h-37 my-1" />
          </div>

          <div
            *ngIf="product?.short_description"
            [innerHTML]="product?.short_description"
            class="text-sm text-gray-500 mb-1"
          ></div>

          <!--<div *ngIf="product?.description" [innerHTML]="product?.description" class="text-sm text-gray-500 mb-8"></div>-->

          <div
            *ngIf="getPrice(product) && product?.allow_self_contracting !== 0"
            class="mt-auto"
          >
            <!-- <div
            *ngIf="product?.tachado"
            class="text-sm"
            style="
              text-decoration: line-through;
              text-decoration-color: rgb(248 113 113);
            "
          >
            <span class="text-customLightBlue text-m font-bold">{{
              product?.tachado
            }}</span>
            <span>{{ getPrice(product).periodicity }}</span>
          </div> -->
            <!--<p class="text-sm mt-2 text-primary ">Aplican restricciones</p>-->

            <!-- Si hay descuento -->
            <div
              class="font-normal text-sm"
              *ngIf="
                getPrice(product).original_price != getPrice(product).price
              "
            >
              <span
                style="text-decoration-line: line-through"
                class="text-primary text-lg font-semibold"
              >
                ${{ formatNumber(getPrice(product).original_price) }}
              </span>
              <div class="relative flex items-center justify-center">
                <div
                  class="bg-gradient-to-br from-primary to-blue-900 font-bold text-center py-3 px-8 rounded-2xl text-white w-full shadow-medium"
                >
                  <div class="absolute" style="top: -12px; right: -12px">
                    <div
                      class="rounded-full text-sm font-bold bg-gradient-to-br from-secondary to-green-600 text-white p-2 w-12 h-12 flex items-center justify-center shadow-strong animate-pulse"
                      style="z-index: 10"
                    >
                      {{ getPrice(product).percentage }}%
                    </div>
                  </div>
                  <span class="text-xl">
                    ${{ formatNumber(getPrice(product).price) }}
                  </span>
                  <br />
                  <span class="font-light text-xs">
                    {{ getPrice(product).periodicity_label }}
                  </span>
                </div>
              </div>

              <p class="mt-2">
                <span class="text-xs">
                  <span
                    *ngIf="getPrice(product)?.cost == 0"
                    class="block text-green-500"
                  >
                    Instalación Gratis
                  </span>
                </span>
                <span
                  *ngIf="getPrice(product)?.original_cost == 0"
                  class="block text-green-500"
                >
                  Instalación Gratis
                </span>
                <span
                  *ngIf="getPrice(product)?.original_cost != 0"
                  class="block"
                  style="
                    color: rgb(248 113 113);
                    text-decoration-line: line-through;
                  "
                >
                  Costo de instalación: ${{
                    formatNumber(getPrice(product)?.original_cost)
                  }}
                </span>
                <span
                  class="font-normal text-gray-500 leading-none"
                  style="font-size: 10px"
                  >Precio sin impuestos nacionales: ${{
                    formatNumber(landingService.priceWithoutIva(product))
                  }}
                </span>
              </p>
            </div>

            <!-- Si no tiene descuento -->
            <div
              *ngIf="
                getPrice(product).original_price == getPrice(product).price
              "
            >
              <button
                class="bg-gradient-to-br from-primary to-blue-900 font-bold text-center py-3 px-10 rounded-full text-white w-fit shadow-medium hover:shadow-strong transition-all duration-300"
              >
                <span
                  >${{ formatNumber(getPrice(product).original_price) }}</span
                >

                <span class="font-normal text-sm">{{
                  getPrice(product).periodicity
                }}</span>
              </button>

              <p class="mt-2">
                <span class="block text-xs text-primary font-semibold">
                  <span *ngIf="getPrice(product)?.original_cost == 0"
                    >Instalación Gratis</span
                  >
                  <span *ngIf="getPrice(product)?.original_cost != 0"
                    >Costo de instalación ${{
                      formatNumber(getPrice(product)?.original_cost)
                    }}</span
                  >
                </span>
                <span
                  class="font-normal text-gray-500 leading-none mt-0 pt-0"
                  style="font-size: 9px"
                  >Precio sin impuestos nacionales: ${{
                    formatNumber(landingService.priceWithoutIva(product))
                  }}
                </span>
              </p>
            </div>
          </div>

          <!--<button *ngIf="!zip_code" (click)="productDetail(product)"
          class="bg-secondary text-sm font-medium px-4 py-1 rounded-full text-white mt-4 flex items-center mx-auto">Contratar</button>
        <button *ngIf="zip_code" (click)="productDetail(product)"
          class="bg-secondary text-sm font-medium px-4 py-1 rounded-full text-white mt-4 flex items-center mx-auto">Contratar</button>
        <a *ngIf="zip_code" (click)="productDetail(product)" class="text-sm font-semibold">Ver detalles</a>-->
        </div>
      </div>
    </div>

    <!-- Botón siguiente (solo desktop y cuando hay más de 4) -->
    <button
      class="text-primary hidden md:block ml-3 transition-all duration-200 hover:opacity-70 hover:scale-110"
      (click)="nextProducts()"
      *ngIf="showCarousel"
      aria-label="Siguiente"
    >
      <svg
        class="w-10 h-10"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        ></path>
      </svg>
    </button>
  </div>
</section>
<app-whyus></app-whyus>
<app-our-filters></app-our-filters>
<app-certificated-filter></app-certificated-filter>
<!-- <app-landing-opinions></app-landing-opinions> -->
<!-- <app-zip-code-form></app-zip-code-form> -->
<!-- <app-landing-faqs></app-landing-faqs> -->
